import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'; 
import GoogleSignIn from './GoogleSignIn';
import Title from './dev/Title';
import Input from './dev/Input'
import Submit from './dev/Submit';
import Response from './dev/Response';
import { fromEvent } from 'rxjs'
import { debounceTime } from 'rxjs/operators';
import LoadingSpinner from '../dev/LoadingSpinner';
import StyleLink from '../dev/StyleLink' //垃圾 PM 加的

const { REACT_APP_URI = '/' } = process.env
class Register extends Component {
    state= {
        registerPassword: '',
        nextRegisterPassword: '',
        isPasswordMatch: '',
        isEmailExsit: '',
        isGoogleSignUpAccount: '',
        isButtonActive: false,
        isLoading: false,
        response: '',
        isAgreeTerms: false, //垃圾 PM 加的
    }
    
    componentDidMount() {
        const { checkEmailExsit, props: {user: {email}} } = this
        checkEmailExsit(email)
        const emailObservable = fromEvent(document.querySelector('#registerObservableInput'), "input")
        emailObservable
            .pipe(debounceTime(500))
            .subscribe(e => {
                const { target: { value } } = e;
                if (value === '') this.setState({ isEmailExsit: '', isGoogleSignUpAccount: ''})
                if(this.isEmail(value)){
                    checkEmailExsit(value)
                }
            })
    }
    checkEmailExsit = (email) => {
        const { token } = this.props.user
        fetch(`${REACT_APP_URI}/accounts/emailCheck/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ email: email })
        })
        .then(res => {
            if (res.status === 200) this.setState({ isEmailExsit: false})
            if (res.status === 400) this.setState({ isEmailExsit: true})
            return res.json()
        })
        .then(isGoogleSignUpAccount => this.setState({ ...isGoogleSignUpAccount }))
    }
    isEmail = email => {
        const regex = /^([a-zA-Z0-9_.\-+])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(email)) {
            return false;
        }
        else {
            return true;
        }
    }
    profileInput = condition => e => {
        const { target: { value } } = e;
        this.setState({[`${condition}`]: value }, () => this.matchPassword())
    }
    matchPassword = () => {
        const { registerPassword, nextRegisterPassword } = this.state
        if (registerPassword === '' || nextRegisterPassword === '') return;
        if (registerPassword === nextRegisterPassword) this.setState({isPasswordMatch: true})
        else this.setState({ isPasswordMatch: false })
    }
    profileSubmit = () => {
        const { messages } = this.props
        if (this.isButtonActive() ==='disabled') return 
        this.setState({ isLoading: true,})
        const { email, token } = this.props.user
        const { registerPassword, nextRegisterPassword } = this.state
        fetch(`${REACT_APP_URI}/accounts/register/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ email: email, password1: registerPassword, password2: nextRegisterPassword })
        })
        .then(res => res.status === 200 && this.setState({response: messages.user_signup_success, isLoading: false,}))
    }
    isButtonActive = () => {
        if (this.state.isPasswordMatch && !this.state.isEmailExsit && this.isEmail(this.props.user.email) && this.state.isAgreeTerms) return ''
        else return 'disabled'
    }
    
    handleInputChange= (event) => { //垃圾 PM 加的 Checkbox狀態管理
        const target = event.target;
        if(target.checked === true) this.setState({isAgreeTerms: true})
        else this.setState({isAgreeTerms: false})
      }

    render() {
        const { user: { email }, messages } = this.props
        const emailInput = e => {
            const { target: { value } } = e;
            this.props.dispatch({ type: `emailInput`, email: value })
        }
        const { registerPassword, nextRegisterPassword, isPasswordMatch, isEmailExsit, isGoogleSignUpAccount, response, isLoading } = this.state
        const { profileInput, profileSubmit, isButtonActive } =this
        return (
            <Container>
                <div>
                    <Title>{messages.user_fast_signup}</Title>
                    <GoogleSignIn/>
                    <Input
                        id="registerObservableInput"
                        onInput={emailInput} value={email}
                        onKeyPress={e => e.key === "Enter" && profileSubmit()}
                        placeholder={messages.user_email_signup} autoFocus />
                    {isEmailExsit && <Response>
                        {isGoogleSignUpAccount ? messages.sign_in_with_google_plz : messages.user_has_been_taken}
                    </Response>}
                    <Input
                        onInput={profileInput('registerPassword')} value={registerPassword}
                        onKeyPress={e => e.key === "Enter" && profileSubmit()}
                        type="password" placeholder={messages.user_password_signup} />
                    <Input
                        onInput={profileInput('nextRegisterPassword')} value={nextRegisterPassword}
                        onKeyPress={e => e.key === "Enter" && profileSubmit()}
                        type="password" placeholder={messages.user_confirm_password} />
                    <Terms>  {/*從這邊開始垃圾 PM 要發功了喔*/}
                        <Checkbox>
                            <Input name="isAgreeTerms" type="checkbox" onChange={this.handleInputChange} />         
                        </Checkbox>
                        {messages.user_terms_agree}&nbsp;
                        <StyleLink to={`/PrivacyPolicy`} target={'_blank'}>
                            <TermText>{messages.footer_privacy_policy},&nbsp;</TermText>
                        </StyleLink>
                        <StyleLink to={`/TermofService`} target={'_blank'}>
                            <TermText>{messages.footer_term_of_service}</TermText>
                        </StyleLink>
                    </Terms> {/*垃圾 PM 發功結束*/}
                    {isPasswordMatch === false && <Response>{messages.user_password_not_match}</Response>}
                    <Submit onClick={profileSubmit} disabled={isButtonActive()}>{messages.user_signup}</Submit>
                    {isLoading && <LoadingSpinner/>}
                    {response === messages.user_signup_success && <Response>{response}</Response>}
                </div>
                <Footer>
                    <div>
                        <div>{messages.user_already_signup}</div>
                    </div>
                    <SignIn onClick={() => this.props.dispatch({ type: 'changeUserCondition', condition: 'signIn' })}>{messages.nav_login}</SignIn>
                </Footer>
            </Container>
        )
    }
    
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(Register);
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-height: 270px;
    text-align: center;
`
const Footer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 14px;
    font-weight: 300;
    div {
        cursor: pointer;
        &:nth-child(1){
            padding-right: 10px;
        }
        &:nth-child(2){
            padding-left: 10px;
        }
    }
`
const SignIn = styled.div`
    color: #de0606;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
`
const Terms = styled.div` 
    display: flex;
    width: 100%;
    font-size: 12px;
    font-weight: 300;
    text-align: center;
    padding:0 0 16px 0;
`
const Checkbox = styled.div`
    position: relative;
    display: flex;
    width: 16px;
    height: 16px;
    display:inline-block;
`

const TermText = styled.div`
    font-weight: 500;
    cursor: pointer;
    color: #de0606;
`


// WEBPACK FOOTER //
// ./src/User/Register.js